import './ValidationCodeDialog.css';

import React, { useState, useEffect } from 'react';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import { InputOtp } from 'primereact/inputotp';
import axios from 'axios';
import { useMediaQuery } from 'react-responsive';

import * as config from '../Config/api.js'; // ✅ ajuste correto conforme estrutura existente

const ValidationCodeDialog = ({ visible, onHide, email, phone, onSuccess, setAlert, setAlertTitle, setAlertBody }) => {
  
  const [loading, setLoading] = useState(false);
  const [loadingConfirm, setLoadingConfirm] = useState(false);
  const [code, setCode] = useState([]);
  const [token, setToken] = useState(null);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [waitToResend, setWaitToResend] = useState(true);

  var timer = null; // controle timer

  const isMobile = useMediaQuery({ query: '(max-width: 767px)' });

  useEffect(() => {
    if (visible) {
      generateCode();
      setCode('');
      setError(null);

      setWaitToResend(true);
      timer = setTimeout(function() {
          setWaitToResend(false);
      },45000);
    } else {
      clearTimeout(timer);
    }
  }, [visible]);

  const generateCode = async () => {
    try {
      setLoadingConfirm(true);
      const response = await axios.post(`${config.API_URL}/company/generateValidationCode`, { email, phone });
      if (response.data?.status) {

        setToken(response.data.token);
        setSuccess('Código gerado e enviado com sucesso.');
        setTimeout(() => {
          setSuccess(null);
        }, 5000); // Limpa a mensagem de sucesso após 5 segundos

      } else {
        throw new Error(response.data?.message || 'Erro ao gerar código');
      }
    } catch (err) {
      setAlertTitle('Erro ao tentar gerar o código');
      setAlertBody('Ocorreu um erro ao tentar gerar o código de validação. Tente novamente. Erro:'+err.message);
      setAlert(true);
      onHide();
    } finally {
      setLoadingConfirm(false);
    }
  };

  const confirmCode = async () => {
    try {
      if (!code || !token) return;
      setLoadingConfirm(true);
      const response = await axios.post(`${config.API_URL}/company/confirmValidationCode`, { code, token });
      if (response.data?.status) {
        setAlertTitle('Validação concluída');
        setAlertBody('Seu e-mail e telefone foram validados com sucesso. Você pode prosseguir para a próxima etapa.');
        setAlert(true);
        onSuccess();
        onHide();
      } else {
        const msg = response.data?.message || 'Código inválido.';
        if (msg.toLowerCase().includes('expirado')) {

          setError('O código expirou. Solicite um novo.');
          setTimeout(() => {setError(null);}, 6000); // Limpa a mensagem de erro após 5 segundos

        } else if (msg.toLowerCase().includes('inválido')) {
          setError('O código digitado está incorreto. Verifique e tente novamente.');
          setTimeout(() => {setError(null);}, 6000); // Limpa a mensagem de erro após 5 segundos
        } else {
          setError(msg);
          setTimeout(() => {setError(null);}, 6000); // Limpa a mensagem de erro após 5 segundos
        }
      }
    } catch (err) {
      setError('Código inválido. Verifique o código e tente novamente.');
      setTimeout(() => {setError(null);}, 6000); // Limpa a mensagem de erro após 5 segundos
    } finally {
      setLoadingConfirm(false);
    }
  };

const resendCode = async () => {
  generateCode();
};

  return (
    <Dialog visible={visible} style={{ width:isMobile ? '90%' : '400px' }} modal onHide={onHide}className="codeValidationDialog">
      <div className="p-fluid codeValidationWrapper">
        <div className="codeValidationTitle">Confirmação de [e-mail/telefone]</div>
        <p className="codeValidationDescription">Confirme o código que te enviamos para [e-mail/WhatsApp].</p>
       
        {/*<InputText
          placeholder="Digite o código recebido"
          value={code}
          style={{marginTop:'2.5rem'}}
          maxLength={6}
          autoFocus
          onChange={(e) => setCode(e.target.value)}
          className={error ? 'p-invalid' : ''}
        />*/}
        <p className="codeValidationDescription" style={{marginTop:'2.5rem'}}>Digite o código</p>        
        <InputOtp 
          integerOnly
          value={code}
          onChange={(e) => setCode(e.value)}
          className={error ? 'p-invalid' : ''}
          invalid={error ? 'p-invalid' : ''}
          length={6}
          style={{marginTop:'0.5rem'}}
        />
        {error && <><small className="p-error">{error}</small><br /></>}
        {success && <><small className="p-success" style={{color:"green"}}>{success}</small><br /></>}
        
        <small className="codeValidationExpire">O código enviado expira em <strong>15min</strong> à partir de agora.</small>

        <div className="p-d-flex p-jc-end" style={{ marginTop: '2.5rem' }}>
          <Button label={loadingConfirm ? "Gerando código..." : "Confirmar"} onClick={confirmCode} loading={loadingConfirm} disabled={loadingConfirm || code.length < 6} className="filledButton" />
        </div>

        <div className="flex-column justify-center align-items-center" style={{ marginTop: '1rem' }}>
          <Button text label="Reenviar o código" onClick={resendCode} loading={loading} disabled={loading || waitToResend} className="textButton" />
          {waitToResend && (<small>Aguarde 45 segundos até poder reenviar</small>)}
          {!waitToResend && (<small>Se não recebeu o código, solicite o reenvio</small>)}
        </div>

      </div>
    </Dialog>
  );
};

export default ValidationCodeDialog;
